var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSparks = function SvgSparks(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m16 4-2.55 7.75a2.667 2.667 0 0 1-1.7 1.7L4 16l7.75 2.55a2.667 2.667 0 0 1 1.7 1.7L16 28l2.55-7.75a2.667 2.667 0 0 1 1.7-1.7L28 16l-7.75-2.55a2.667 2.667 0 0 1-1.7-1.7L16 4ZM6.667 4v5.333M25.333 22.667V28M4 6.667h5.333M22.667 25.333H28"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSparks);
export default ForwardRef;